import styled from 'styled-components';

const SVG = styled.i`
  -webkit-mask:  url(${({ path }) => path}) no-repeat 50% 50%;
  mask: url(${({ path }) => path}) no-repeat 50% 50%;
  mask-size: 100% 100%;
  display: block;
`;

export default SVG;